import { Builder } from '@builder.io/react';

import QuoteUI from './index';

Builder.registerComponent(QuoteUI, {
  name: 'QuoteUI',
  inputs: [
    {
      name: 'image',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'gradientText',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'centered',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'quotes',
      type: 'list',
      subFields: [
        {
          name: 'logo',
          type: 'object',
          defaultValue: [
            {
              src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2Fafedd6f01a9e42fa8aed1b4d1fd5b297'
            }
          ],
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
              defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2Fafedd6f01a9e42fa8aed1b4d1fd5b297'
            },
            {
              name: 'alt',
              type: 'string'
            },
            { name: 'width', type: 'number' },
            { name: 'height', type: 'number' }
          ]
        },
        {
          name: 'img',
          type: 'object',
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            {
              name: 'alt',
              type: 'string'
            }
          ]
        },
        {
          name: 'content',
          type: 'longText'
        },
        {
          name: 'profile',
          type: 'string'
        },
        {
          name: 'position',
          type: 'string'
        }
      ]
    }
  ]
});
